import { Action } from '@ngrx/store'
import { User } from '@spartacus/core'
import { MbCartMigrationContext } from '../../../models'
import { Cart } from '@spartacus/cart/base/root'

export const MIGRATE_CART = '[Checkout] Migrate Cart'
export const MIGRATE_CART_SUCCESS = '[Checkout] Migrate Cart Success'
export const MIGRATE_CART_FAIL = '[Checkout] Migrate Cart Fail'

export class MigrateCart implements Action {
  readonly type = MIGRATE_CART

  constructor (public payload: { userId: string; cartId: string; cartMigrationInfo: MbCartMigrationContext; isLoginProcess?: boolean }) { }
}

export class MigrateCartSuccess implements Action {
  readonly type = MIGRATE_CART_SUCCESS
  constructor (public payload: { migratedCart: Cart; isLoginProcess: boolean; user?: User; userHasNoCart?: boolean }) { }
}

export class MigrateCartFail implements Action {
  readonly type = MIGRATE_CART_FAIL
  constructor (public payload: any) { }
}
